<template>
  <div>
    <v-divider></v-divider>
    <v-card-actions class @click.stop="show = !show">
      <h3 class>{{ title }}</h3>
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="show = !show">
        <v-icon v-if="show">fa-minus</v-icon>
        <v-icon v-else>fa-chevron-down</v-icon>
      </v-btn>
    </v-card-actions>
    <v-expand-transition>
      <div v-show="show">
        <v-container>
          <v-row>
            <v-col cols="12" lg="4">
              <img
                :src="image"
                v-if="image"
                style="width: 100%; height: auto"
              />
            </v-col>
            <v-col cols="12" lg="8">
              <div>
                <blockquote v-html="description"></blockquote>

                <div v-if="link" class="mt-2">
                  <a :href="link" target="_blank">More Info</a>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: "ProjectSection",
  props: ["title", "image", "description", "link"],
  data() {
    return {
      show: true,
    };
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0px;
}
</style>